module.exports = __webpack_public_path__ + "static/img/hengye_8@2x.92b517ac.png";